module.exports = __webpack_public_path__ + "img/bg-image-7.269c71f6.jpg";